import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {EventText} from '../../../../../../commons/components/event-text'
import {useMembersPageCurrencyFormatter} from '../../../hooks/currency'
import {Divider} from '../../styled-components/divider'
import sc from '../common.scss'
import {TicketProps} from './interfaces'
import s from './ticket.scss'

export const Ticket = ({item}: TicketProps) => {
  const {t} = useTranslation()
  const {getFormattedMoney} = useMembersPageCurrencyFormatter()
  const {name, price, quantity, total} = item

  return (
    <>
      <div className={sc.section} data-hook={DH.TICKET}>
        <div>
          <EventText>{name}</EventText>
        </div>
        <div className={classNames(s.price, sc.splitRow)}>
          <EventText faded>{t('mobile.order.ticket.price')}</EventText>
          <EventText faded>{getFormattedMoney(price)}</EventText>
        </div>
        <div className={classNames(s.quantity, sc.splitRow)}>
          <EventText faded>{t('mobile.order.ticket.quantity')}</EventText>
          <EventText faded>{quantity}</EventText>
        </div>
        <div className={classNames(s.ticketTotal, sc.splitRow)} data-hook={DH.TICKET_TOTAL}>
          <EventText>{t('mobile.order.ticket.total')}</EventText>
          <EventText>{getFormattedMoney(total)}</EventText>
        </div>
      </div>
      <Divider />
    </>
  )
}
